<template>
  <div class="page-wrapper">
    <!-- ====================== PC 端 ====================== -->
    <div class="pc-version">
      <div
        class="menu-table-container"
        v-loading="loading"
        element-loading-text="拼命加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.3)"
      >
        <div class="search-bar">
          <el-input
            v-model="searchParams.title"
            placeholder="请输入商品名称"
            clearable
            style="width: 220px; margin-right: 10px"
          ></el-input>

          <el-button type="primary" icon="el-icon-search" @click="getList"
            >搜索</el-button
          >
          <el-button icon="el-icon-refresh" @click="resetSearch"
            >重置</el-button
          >
          <el-button type="success" icon="el-icon-plus" @click="handlePcAdd"
            >添加商品</el-button
          >
        </div>

        <el-table
          :data="tableData"
          border
          stripe
          style="width: 100%; margin-top: 20px"
          @row-click="handlePcRowClick"
        >
          <el-table-column label="ID" prop="id" width="80" align="center" />
          <el-table-column label="商品名称" prop="title" min-width="200" />
          <el-table-column label="商品图片" width="120" align="center">
            <template slot-scope="scope">
              <img
                :src="scope.row.goods_img"
                style="width: 60px; height: 60px; object-fit: cover"
              />
            </template>
          </el-table-column>
          <el-table-column
            label="售价"
            prop="price"
            width="100"
            align="center"
          />
          <el-table-column
            label="销售价"
            prop="sale_price"
            width="100"
            align="center"
          />
          <el-table-column
            label="库存数量"
            prop="origin_num"
            width="100"
            align="center"
          />
          <el-table-column
            label="已售数量"
            prop="num"
            width="100"
            align="center"
          />

          <!-- 状态列 -->
          <el-table-column label="状态" width="180" align="center">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.status"
                active-text="上架"
                inactive-text="下架"
                :active-value="1"
                :inactive-value="0"
                @click.native.stop
                @change="handleStatus(scope.row)"
              />
            </template>
          </el-table-column>

          <el-table-column label="创建时间" prop="created_at" width="180" />

          <!-- 操作列 -->
          <el-table-column
            label="操作"
            fixed="right"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-edit"
                @click.stop="handlePcEdit(scope.row)"
                >编辑</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchParams.page"
          :page-size="searchParams.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageInfo.total"
          style="margin-top: 20px; text-align: right"
        ></el-pagination>

        <!-- PC 详情弹窗 -->
        <el-dialog
          title="商品详情"
          :visible.sync="pcShowCard"
          width="500px"
          center
          close-on-click-modal
          append-to-body
        >
          <div class="goods-card" v-if="pcCurrentRow">
            <div class="goods-img">
              <img :src="pcCurrentRow.goods_img" alt="图片" />
            </div>
            <div class="goods-info">
              <p>
                <label>ID：</label><span>{{ pcCurrentRow.id }}</span>
              </p>
              <p>
                <label>名称：</label><span>{{ pcCurrentRow.title }}</span>
              </p>
              <p>
                <label>售价：</label><span>{{ pcCurrentRow.price }}</span>
              </p>
              <p>
                <label>销售价：</label
                ><span>{{ pcCurrentRow.sale_price }}</span>
              </p>
              <p>
                <label>库存：</label><span>{{ pcCurrentRow.origin_num }}</span>
              </p>
              <p>
                <label>已售：</label><span>{{ pcCurrentRow.num }}</span>
              </p>
              <p>
                <label>状态：</label>
                <span
                  :style="
                    pcCurrentRow.status == 1 ? 'color:#00C48C' : 'color:#F56C6C'
                  "
                >
                  {{ pcCurrentRow.status == 1 ? "上架" : "下架" }}
                </span>
              </p>
              <p>
                <label>创建时间：</label
                ><span>{{ pcCurrentRow.created_at }}</span>
              </p>
              <p>
                <label>商品描述：</label
                ><span>{{ pcCurrentRow.content || "无" }}</span>
              </p>
            </div>
          </div>
        </el-dialog>

        <!-- PC 添加/编辑弹窗 -->
        <el-dialog
          :title="pcDialogType == 'add' ? '添加商品' : '编辑商品'"
          :visible.sync="pcDialogVisible"
          width="600px"
          @close="pcResetForm"
          append-to-body
        >
          <el-form
            :model="pcForm"
            :rules="addRules"
            ref="pcFormRef"
            label-width="110px"
          >
            <!-- 替换为商品图片选择项 -->
            <el-form-item label="商品图片" prop="image">
              <div style="display: flex; align-items: center; gap: 12px">
                <el-button
                  type="primary"
                  icon="el-icon-picture"
                  @click="pcOpenImageDialog"
                  >选择图片</el-button
                >
                <div
                  v-if="pcForm.goods_img"
                  style="
                    border: 1px solid #eee;
                    padding: 4px;
                    border-radius: 4px;
                  "
                >
                  <img
                    :src="pcForm.goods_img"
                    style="
                      width: 52px;
                      height: 52px;
                      object-fit: cover;
                      display: block;
                    "
                  />
                </div>
              </div>
            </el-form-item>

            <el-form-item label="商品名称" prop="title">
              <el-input
                v-model="pcForm.title"
                placeholder="请输入商品名称"
                style="width: 300px"
              />
            </el-form-item>

            <el-form-item label="售价" prop="price">
              <el-input
                v-model="pcForm.price"
                placeholder="请输入售价"
                style="width: 300px"
              />
            </el-form-item>

            <el-form-item label="销售价" prop="sale_price">
              <el-input
                v-model="pcForm.sale_price"
                placeholder="请输入销售价"
                style="width: 300px"
              />
            </el-form-item>

            <el-form-item label="库存数量" prop="num">
              <el-input
                v-model="pcForm.num"
                placeholder="请输入库存数量"
                style="width: 300px"
              />
            </el-form-item>

            <el-form-item label="商品描述" prop="content">
              <el-input
                v-model="pcForm.content"
                type="textarea"
                rows="3"
                placeholder="请输入商品描述"
                style="width: 300px"
              />
            </el-form-item>
          </el-form>

          <div slot="footer">
            <el-button @click="pcDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="pcSubmitForm">确认提交</el-button>
          </div>
        </el-dialog>

        <!-- PC 图片选择弹窗 -->
        <el-dialog
          title="选择图片"
          :visible.sync="pcImageDialogVisible"
          width="850px"
          append-to-body
        >
          <div
            v-loading="imageLoading"
            element-loading-text="图片加载中..."
            style="padding: 10px"
          >
            <div
              style="
                display: flex;
                gap: 10px;
                margin-bottom: 15px;
                align-items: center;
              "
            >
              <el-select
                v-model.number="pcImageSearch.type"
                placeholder="图片类型"
                style="width: 180px"
                clearable
              >
                <el-option
                  v-for="item in image_type"
                  :key="item.type"
                  :label="item.desc"
                  :value="item.type"
                />
              </el-select>
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="getImageList"
                >筛选</el-button
              >
              <el-button icon="el-icon-refresh" @click="resetImageSearch"
                >重置</el-button
              >
            </div>

            <div
              style="
                display: flex;
                flex-wrap: wrap;
                gap: 12px;
                max-height: 420px;
                overflow-y: auto;
                padding: 5px;
              "
            >
              <div
                v-for="img in imageList"
                :key="img.id"
                @click="pcSelectImage(img)"
                style="
                  cursor: pointer;
                  padding: 4px;
                  border-radius: 6px;
                  text-align: center;
                "
                :style="{
                  border:
                    pcSelectedImageUrl == img.url
                      ? '2px solid #1989fa'
                      : '2px solid transparent',
                  background:
                    pcSelectedImageUrl == img.url ? '#f0f7ff' : 'transparent',
                }"
              >
                <img
                  :src="img.url"
                  style="
                    width: 100px;
                    height: 100px;
                    object-fit: cover;
                    border-radius: 4px;
                    display: block;
                  "
                />
                <span
                  style="
                    font-size: 12px;
                    margin-top: 4px;
                    color: #666;
                    display: block;
                  "
                >
                  {{ getImageTypeName(img.type) }}
                </span>
              </div>
            </div>

            <el-pagination
              @size-change="handleImageSizeChange"
              @current-change="handleImageCurrentChange"
              :current-page="pcImageSearch.page"
              :page-size="pcImageSearch.page_size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="imageTotal"
              style="margin-top: 15px; text-align: right"
            ></el-pagination>
          </div>

          <div slot="footer">
            <el-button @click="pcImageDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="pcConfirmSelectImage"
              >确认选择</el-button
            >
          </div>
        </el-dialog>
      </div>
    </div>

    <!-- ====================== 移动端 ====================== -->
    <div class="mobile-version">
      <div
        class="mobile-goods-container"
        v-loading="loading"
        element-loading-text="加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0,0,0,0.4)"
      >
        <div class="mobile-search-group">
          <el-input
            v-model="searchParams.title"
            placeholder="商品名称"
            clearable
            size="medium"
            prefix-icon="el-icon-search"
          />

          <div style="display: flex; gap: 8px; margin-top: 8px">
            <el-button
              type="primary"
              plain
              round
              @click="getList"
              style="flex: 1"
              >搜索</el-button
            >
            <el-button plain round @click="resetSearch" style="flex: 1"
              >重置</el-button
            >
            <el-button
              type="success"
              plain
              round
              @click="handleMobileAdd"
              style="flex: 1"
              >添加</el-button
            >
          </div>
        </div>

        <div class="mobile-card-list">
          <div
            class="mobile-card"
            v-for="item in tableData"
            :key="item.id"
            @click="handleMobileRowClick(item)"
          >
            <div class="card-header">
              <img :src="item.goods_img" class="avatar" />
              <div class="info">
                <div class="title">{{ item.title }}</div>
                <div class="meta">
                  ID:{{ item.id }} | 售价:¥{{ item.price }}
                </div>
              </div>
              <div class="status" :class="item.status == 1 ? 'on' : 'off'">
                {{ item.status == 1 ? "上架" : "下架" }}
              </div>
            </div>
            <div class="card-body">
              <div>销售价：¥{{ item.sale_price }}</div>
              <div>库存：{{ item.origin_num }}</div>
              <div>已售：{{ item.num }}</div>
            </div>
            <div class="card-footer">
              <el-button
                size="mini"
                type="primary"
                round
                @click.stop="handleMobileEdit(item)"
                >编辑</el-button
              >
              <el-switch
                v-model="item.status"
                size="mini"
                active-text="上架"
                inactive-text="下架"
                :active-value="1"
                :inactive-value="0"
                @click.native.stop
                @change="handleStatus(item)"
              />
            </div>
          </div>
        </div>

        <div style="text-align: center; margin-top: 15px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="searchParams.page"
            :page-size="searchParams.page_size"
            layout="total, prev, pager, next, jumper"
            :total="pageInfo.total"
            pager-count="2"
            small
          />
        </div>

        <!-- 移动端详情 -->
        <el-dialog
          title="商品详情"
          :visible.sync="mobileShowCard"
          width="95%"
          top="8vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <div v-if="mobileCurrentRow" style="padding: 10px 0">
            <div style="text-align: center; margin-bottom: 15px">
              <img
                :src="mobileCurrentRow.goods_img"
                style="
                  width: 120px;
                  height: 120px;
                  object-fit: cover;
                  border-radius: 8px;
                "
              />
            </div>
            <el-descriptions :column="1" border size="small">
              <el-descriptions-item label="ID">{{
                mobileCurrentRow.id
              }}</el-descriptions-item>
              <el-descriptions-item label="商品名称">{{
                mobileCurrentRow.title
              }}</el-descriptions-item>
              <el-descriptions-item label="售价"
                >¥{{ mobileCurrentRow.price }}</el-descriptions-item
              >
              <el-descriptions-item label="销售价"
                >¥{{ mobileCurrentRow.sale_price }}</el-descriptions-item
              >
              <el-descriptions-item label="库存">{{
                mobileCurrentRow.origin_num
              }}</el-descriptions-item>
              <el-descriptions-item label="已售">{{
                mobileCurrentRow.num
              }}</el-descriptions-item>
              <el-descriptions-item label="描述">{{
                mobileCurrentRow.content || "无"
              }}</el-descriptions-item>
              <el-descriptions-item label="状态">
                <span
                  :style="
                    mobileCurrentRow.status == 1
                      ? 'color:#00C48C'
                      : 'color:#F56C6C'
                  "
                >
                  {{ mobileCurrentRow.status == 1 ? "上架" : "下架" }}
                </span>
              </el-descriptions-item>
            </el-descriptions>
          </div>
          <div slot="footer" style="text-align: right">
            <el-button @click="mobileShowCard = false">关闭</el-button>
          </div>
        </el-dialog>

        <!-- 移动端添加/编辑 -->
        <el-dialog
          :title="mobileDialogType == 'add' ? '添加商品' : '编辑商品'"
          :visible.sync="mobileDialogVisible"
          width="95%"
          top="10vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <el-form
            :model="mobileForm"
            :rules="addRules"
            ref="mobileFormRef"
            label-width="90px"
            size="small"
          >
            <!-- 替换为图片选择 -->
            <el-form-item label="商品图片" prop="image">
              <div style="display: flex; align-items: center; gap: 10px">
                <el-button
                  type="primary"
                  size="mini"
                  @click="mobileOpenImageDialog"
                  >选择图片</el-button
                >
                <div
                  v-if="mobileForm.goods_img"
                  style="
                    border: 1px solid #eee;
                    padding: 2px;
                    border-radius: 4px;
                  "
                >
                  <img
                    :src="mobileForm.goods_img"
                    style="width: 46px; height: 46px; object-fit: cover"
                  />
                </div>
              </div>
            </el-form-item>

            <el-form-item label="商品名称" prop="title">
              <el-input
                v-model="mobileForm.title"
                placeholder="商品名称"
                size="medium"
              />
            </el-form-item>
            <el-form-item label="售价" prop="price">
              <el-input
                v-model="mobileForm.price"
                placeholder="售价"
                size="medium"
              />
            </el-form-item>
            <el-form-item label="销售价" prop="sale_price">
              <el-input
                v-model="mobileForm.sale_price"
                placeholder="销售价"
                size="medium"
              />
            </el-form-item>
            <el-form-item label="库存数量" prop="num">
              <el-input
                v-model.number="mobileForm.num"
                placeholder="库存数量"
                size="medium"
              />
            </el-form-item>
            <el-form-item label="商品描述" prop="content">
              <el-input
                v-model="mobileForm.content"
                type="textarea"
                rows="2"
                placeholder="商品描述"
                size="medium"
              />
            </el-form-item>
          </el-form>
          <div
            slot="footer"
            style="display: flex; justify-content: flex-end; gap: 10px"
          >
            <el-button size="medium" @click="mobileDialogVisible = false"
              >取消</el-button
            >
            <el-button type="primary" size="medium" @click="mobileSubmitForm"
              >保存</el-button
            >
          </div>
        </el-dialog>

        <!-- 移动端图片选择弹窗 -->
        <el-dialog
          title="选择图片"
          :visible.sync="mobileImageDialogVisible"
          width="95%"
          top="10vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <div
            v-loading="imageLoading"
            element-loading-text="加载中..."
            style="padding: 5px"
          >
            <div style="display: flex; gap: 8px; margin-bottom: 10px">
              <el-select
                v-model.number="mobileImageSearch.type"
                placeholder="类型"
                size="mini"
                clearable
                style="flex: 1"
              >
                <el-option
                  v-for="item in image_type"
                  :key="item.type"
                  :label="item.desc"
                  :value="item.type"
                />
              </el-select>
              <el-button size="mini" type="primary" @click="getImageList"
                >筛选</el-button
              >
              <el-button size="mini" @click="resetImageSearch">重置</el-button>
            </div>
            <div
              style="
                display: flex;
                flex-wrap: wrap;
                gap: 8px;
                max-height: 45vh;
                overflow-y: auto;
                padding: 5px;
              "
            >
              <div
                v-for="img in imageList"
                :key="img.id"
                @click="mobileSelectImage(img)"
                style="
                  padding: 3px;
                  border-radius: 6px;
                  cursor: pointer;
                  text-align: center;
                "
                :style="{
                  border:
                    mobileSelectedImageUrl == img.url
                      ? '2px solid #1989fa'
                      : '2px solid transparent',
                  background:
                    mobileSelectedImageUrl == img.url
                      ? '#f0f7ff'
                      : 'transparent',
                }"
              >
                <img
                  :src="img.url"
                  style="
                    width: 70px;
                    height: 70px;
                    object-fit: cover;
                    border-radius: 4px;
                    display: block;
                  "
                />
                <span
                  style="
                    font-size: 12px;
                    color: #666;
                    margin-top: 3px;
                    display: block;
                  "
                  >{{ img.title }}</span
                >
              </div>
            </div>

            <div style="margin-top: 10px; text-align: center">
              <el-pagination
                @size-change="handleImageSizeChange"
                @current-change="handleImageCurrentChange"
                :current-page="mobileImageSearch.page"
                :page-size="mobileImageSearch.page_size"
                layout="prev, pager, next"
                :total="imageTotal"
                pager-count="2"
                small
              />
            </div>
          </div>
          <div slot="footer" style="text-align: right">
            <el-button size="mini" @click="mobileImageDialogVisible = false"
              >取消</el-button
            >
            <el-button
              size="mini"
              type="primary"
              @click="mobileConfirmSelectImage"
              >确认</el-button
            >
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api/api.js";
export default {
  name: "ShopGoods",
  data() {
    return {
      loading: false,
      tableData: [],
      pageInfo: { total: 0 },
      searchParams: {
        page: 1,
        page_size: 10,
        title: "",
      },
      // 表单验证
      addRules: {
        title: [{ required: true, message: "请输入商品名称", trigger: "blur" }],
        price: [{ required: true, message: "请输入售价", trigger: "blur" }],
        sale_price: [
          { required: true, message: "请输入销售价", trigger: "blur" },
        ],
        num: [{ required: true, message: "请输入库存数量", trigger: "blur" }],
        goods_img: [
          { required: true, message: "请选择商品图片", trigger: "change" },
        ],
        content: [],
      },

      // 图片公共数据
      imageLoading: false,
      imageList: [],
      imageTotal: 0,
      image_type: [],

      // PC
      pcShowCard: false,
      pcCurrentRow: null,
      pcDialogVisible: false,
      pcDialogType: "add",
      pcForm: {
        title: "",
        price: "",
        sale_price: "",
        goods_id: "",
        num: "",
        goods_img: "",
        content: "",
        type: "",
      },
      pcImageDialogVisible: false,
      pcImageSearch: {
        page: 1,
        page_size: 10,
        type: "",
      },
      pcSelectedImageUrl: "",
      pcSelectedType: "",

      // 移动端
      mobileShowCard: false,
      mobileCurrentRow: null,
      mobileDialogVisible: false,
      mobileDialogType: "add",
      mobileForm: {
        title: "",
        price: "",
        sale_price: "",
        num: "",
        goods_img: "",
        goods_id: "",
        content: "",
        type: "",
      },
      mobileImageDialogVisible: false,
      mobileImageSearch: {
        page: 1,
        page_size: 10,
        type: "",
      },
      mobileSelectedImageUrl: "",
      mobileSelectedType: "",
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // ==================== 商城商品列表 ====================
    getList() {
      this.loading = true;
      api.shopGoods
        .index({ params: this.searchParams })
        .then((res) => {
          if (res.data.code == 1000) {
            this.tableData = res.data.data.data;
            this.pageInfo.total = res.data.data.total;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // ==================== 状态切换 ====================
    handleStatus(row) {
      const old = row.status;
      this.loading = true;
      api.shopGoods
        .status({
          goods_id: row.id,
          status: row.status,
        })
        .catch(() => {
          row.status = old;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // ==================== 图片相关接口方法 ====================
    getImageList() {
      this.imageLoading = true;
      api.images
        .index({ params: this.pcImageSearch })
        .then((res) => {
          if (res.data.code == 1000) {
            this.imageList = res.data.data.data || [];
            this.imageTotal = res.data.data.total || 0;
            this.image_type = res.data.data.image_type || [];
          }
        })
        .finally(() => {
          this.imageLoading = false;
        });
    },
    resetImageSearch() {
      this.pcImageSearch = {
        page: 1,
        page_size: 10,
        type: "",
      };
      this.mobileImageSearch = {
        page: 1,
        page_size: 10,
        type: "",
      };
      this.getImageList();
    },
    handleImageSizeChange(val) {
      this.pcImageSearch.page_size = val;
      this.mobileImageSearch.page_size = val;
      this.getImageList();
    },
    handleImageCurrentChange(val) {
      this.pcImageSearch.page = val;
      this.mobileImageSearch.page = val;
      this.getImageList();
    },
    getImageTypeName(type) {
      const item = this.image_type.find((t) => t.type == type);
      return item ? item.desc : "未知分类";
    },

    // ==================== PC ====================
    handlePcRowClick(row) {
      this.pcCurrentRow = row;
      this.pcShowCard = true;
    },
    handlePcAdd() {
      this.pcDialogType = "add";
      this.pcResetForm();
      this.pcDialogVisible = true;
    },
    handlePcEdit(row) {
      this.pcDialogType = "edit";
      this.pcForm = {
        title: row.title,
        price: row.price,
        sale_price: row.sale_price,
        num: row.origin_num,
        goods_img: row.goods_img,
        goods_id: row.id,
        content: row.content,
        type: row.type,
      };
      this.pcDialogVisible = true;
    },
    pcResetForm() {
      this.pcForm = {
        title: "",
        price: "",
        sale_price: "",
        num: "",
        goods_img: "",
        goods_id: "",
        content: "",
        type: "",
      };
      this.$nextTick(() => {
        if (this.$refs.pcFormRef) this.$refs.pcFormRef.clearValidate();
      });
    },
    pcSubmitForm() {
      this.$refs.pcFormRef.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        const fn =
          this.pcDialogType == "add" ? api.shopGoods.add : api.shopGoods.edit;
        fn(this.pcForm)
          .then((res) => {
            if (res.data.code == 1000) {
              this.pcDialogVisible = false;
              this.getList();
            }
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    pcOpenImageDialog() {
      this.pcImageDialogVisible = true;
      this.pcSelectedImageUrl = "";
      this.pcSelectedType = "";
      this.getImageList();
    },
    pcSelectImage(img) {
      this.pcSelectedImageUrl = img.url;
      this.pcSelectedType = img.type;
    },
    pcConfirmSelectImage() {
      if (!this.pcSelectedImageUrl) {
        this.$message.warning("请先选择图片");
        return;
      }
      this.pcForm.goods_img = this.pcSelectedImageUrl;
      this.pcForm.type = this.pcSelectedType;
      this.pcImageDialogVisible = false;
    },

    // ==================== 移动端 ====================
    handleMobileRowClick(row) {
      this.mobileCurrentRow = row;
      this.mobileShowCard = true;
    },
    handleMobileAdd() {
      this.mobileDialogType = "add";
      this.mobileResetForm();
      this.mobileDialogVisible = true;
    },
    handleMobileEdit(row) {
      this.mobileDialogType = "edit";
      this.mobileForm = {
        title: row.title,
        price: row.price,
        sale_price: row.sale_price,
        num: row.origin_num,
        goods_img: row.goods_img,
        content: row.content,
        goods_id: row.id,
        type: row.type,
      };
      this.mobileDialogVisible = true;
    },
    mobileResetForm() {
      this.mobileForm = {
        title: "",
        price: "",
        sale_price: "",
        num: "",
        goods_img: "",
        goods_id: "",
        content: "",
        type: "",
      };
      this.$nextTick(() => {
        if (this.$refs.mobileFormRef) this.$refs.mobileFormRef.clearValidate();
      });
    },
    mobileSubmitForm() {
      this.$refs.mobileFormRef.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        const fn =
          this.mobileDialogType == "add"
            ? api.shopGoods.add
            : api.shopGoods.edit;
        fn(this.mobileForm)
          .then((res) => {
            if (res.data.code == 1000) {
              this.mobileDialogVisible = false;
              this.getList();
            }
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    mobileOpenImageDialog() {
      this.mobileImageDialogVisible = true;
      this.mobileSelectedImageUrl = "";
      this.mobileSelectedType = "";
      this.getImageList();
    },
    mobileSelectImage(img) {
      this.mobileSelectedImageUrl = img.url;
      this.mobileSelectedType = img.type;
    },
    mobileConfirmSelectImage() {
      if (!this.mobileSelectedImageUrl) {
        this.$message.warning("请先选择图片");
        return;
      }
      this.mobileForm.goods_img = this.mobileSelectedImageUrl;
      this.mobileForm.type = this.mobileSelectedType;
      this.mobileImageDialogVisible = false;
    },

    // ==================== 公共 ====================
    resetSearch() {
      this.searchParams = {
        page: 1,
        page_size: 10,
        title: "",
      };
      this.getList();
    },
    handleSizeChange(val) {
      this.searchParams.page_size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getList();
    },
  },
};
</script>

<style scoped>
/* PC */
.menu-table-container {
  padding: 20px;
}
.search-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.goods-card {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 10px;
}
.goods-img img {
  width: 120px;
  height: 120px;
  object-fit: cover;
  border-radius: 8px;
}
.goods-info {
  flex: 1;
  font-size: 14px;
}
.goods-info p {
  margin: 10px 0;
  line-height: 1.6;
}
.goods-info label {
  font-weight: bold;
  width: 90px;
  display: inline-block;
}

/* 移动端 */
.mobile-goods-container {
  padding: 12px;
  box-sizing: border-box;
}
.mobile-search-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}
.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.mobile-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}
.avatar {
  width: 50px;
  height: 50px;
  border-radius: 6px;
  object-fit: cover;
}
.info {
  flex: 1;
}
.title {
  font-size: 16px;
  font-weight: 500;
}
.meta {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}
.status {
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 4px;
}
.status.on {
  background: #e6f7ee;
  color: #00c48c;
}
.status.off {
  background: #fef0f0;
  color: #f56c6c;
}
.card-body {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 10px;
}
.card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/shopGoods/index.vue